import React from 'react';
import styles from './security-detail-section.module.scss';
import {Button, Col, Row} from "react-bootstrap";
import {toCurrency} from "../../../../../../helpr/helper";
import SecurityService from '../../../../../../services/security-service';

const SecurityDetailSection = ({sellingAgents, security}) => {
  const securityService = new SecurityService();

  const downloadBPFeed = async () => {
    let entityList = [];
    sellingAgents.forEach(element=>{entityList.push(element['sellingAgentEntityId'])});
    const resp = await securityService.generateBPFeed(security.securityId, entityList.join(','));
    window.open(resp['bpFeedS3FileUrl']);
    window.open(resp['fisipoS3FileUrl']);
  }

  return (
    <div className={styles['security-detail-section']}>
      <Row>
        <Col lg={6}>
          <div className={`${styles['security-header']} ${styles['wrap']}`}>
            { security['securityName'] }
          </div>
          <div className={styles['security-sub-header']}>
            <Row className="mt-1">
              <Col lg={4}>
                ISIN/Security Code:
              </Col>
              <Col>
                { security.securityId ? security.securityId.toUpperCase() : ''}
              </Col>
            </Row>
            <Row className="mt-1">
              <Col lg={4}>
                Offer Size:
              </Col>
              <Col>
                { security.currency}{' '}{ security.offerSize ? toCurrency(security.offerSize) : 0.00}
              </Col>
            </Row>
          </div>
        </Col>
        <Col lg={6}>
          <div className={styles['security-action']}>
            {/* <Button onClick={()=>downloadBPFeed()}>GENERATE BPFEED</Button> */}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default SecurityDetailSection;
